import { defineStore } from 'pinia'
import useCustomFetch from '~/composables/useCustomFetch'

const dataProvider = {
    sport: [
        {
            name: 'KSport',
            key: 'ksports',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'Saba',
            key: 'saba',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'BTI',
            key: 'bti',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'IMSport',
            key: 'imsports',
            label: '',
            number_of_game: 0,
        },
    ],
    virtual_sport: [
        {
            name: 'KSport',
            key: 'ksports',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'IMPlay',
            key: 'implay',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'Saba',
            key: 'saba',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'PPSport',
            key: 'ppsports',
            label: '',
            number_of_game: 0,
        },
    ],
    live_casino: [
        {
            name: 'Vivo',
            key: 'vivo',
            label: 'hot',
            number_of_game: 14,
        },
        {
            name: 'KingMaker',
            key: 'kingmaker',
            label: 'new',
            number_of_game: 0,
        },
        {
            name: 'Dream Gaming',
            key: 'dreamgaming',
            label: 'new',
            number_of_game: 0,
        },
        {
            name: 'Pragmatic',
            key: 'pragmatic',
            label: '',
            number_of_game: 28,
        },
        {
            name: 'Evolution',
            key: 'evo',
            label: '',
            number_of_game: 32,
        },
        {
            name: 'Ezugi',
            key: 'ezugi',
            label: '',
            number_of_game: 14,
        },
        {
            name: 'Micrograming',
            key: 'mg',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'Ho gaming',
            key: 'hogaming',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'Sagaming',
            key: 'sagaming',
            label: '',
            number_of_game: 1,
        },
    ],
    fishing: [
        {
            name: 'Techplay',
            key: 'techplay',
            label: 'hot',
            number_of_game: 0,
        },
        {
            name: 'Jili',
            key: 'jili',
            label: 'new',
            number_of_game: 48,
        },
        {
            name: 'JDB',
            key: 'jdb',
            label: '',
            number_of_game: 7,
        },
        {
            name: 'Fachai',
            key: 'fachai',
            label: '',
            number_of_game: 5,
        },
    ],
    cock_fight: [
        {
            name: 'DIGMAAN',
            key: 'digmaan',
            label: '',
            number_of_game: 0,
        },
    ],
    table_game: [
        {
            name: 'Techplay',
            key: 'techplay',
            label: 'hot',
            number_of_game: 0,
        },
        {
            name: 'Jili',
            key: 'jili',
            label: 'new',
            number_of_game: 48,
        },
        {
            name: "Play'N Go",
            key: 'playngo',
            label: 'new',
            number_of_game: 25,
        },
        {
            name: 'Netent',
            key: 'netent',
            label: '',
            number_of_game: 4,
        },
    ],
    slot: [
        {
            name: 'Techplay',
            key: 'techplay',
            label: 'hot',
            number_of_game: 0,
        },
        {
            name: "Play'N Go",
            key: 'playngo',
            label: 'new',
            number_of_game: 25,
        },
        {
            name: 'Evoplay',
            key: 'evoplay',
            label: 'new',
            number_of_game: 33,
        },
        {
            name: 'PGSOFT',
            key: 'pgsoft',
            label: '',
            number_of_game: 99,
        },
        {
            name: 'Pragmatic',
            key: 'pragmatic',
            label: '',
            number_of_game: 28,
        },
        {
            name: 'RedTiger',
            key: 'redtiger',
            label: '',
            number_of_game: 19,
        },
        {
            name: 'Microgaming',
            key: 'microgaming',
            label: '',
            number_of_game: 34,
        },
        {
            name: 'Qtech',
            key: 'qtech',
            label: '',
            number_of_game: 15,
        },
    ],
    lotto: [
        {
            name: 'Techplay',
            key: 'techplay',
            label: 'hot',
            number_of_game: 0,
        },
        {
            name: 'AskMeLotto',
            key: 'askmelotto',
            label: 'new',
            number_of_game: 0,
        },
        {
            name: 'IBC',
            key: 'ibc',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'Spribe',
            key: 'spribe',
            label: '',
            number_of_game: 9,
        },
    ],
    quick_game: [
        {
            name: 'Evoplay',
            key: 'evoplay',
            label: 'hot',
            number_of_game: 33,
        },
        {
            name: 'Spribe',
            key: 'spribe',
            label: 'new',
            number_of_game: 9,
        },
    ],
    e_sport: [
        {
            name: 'Saba',
            key: 'saba',
            label: '',
            number_of_game: 0,
        },
        {
            name: 'IM',
            key: 'im',
            label: '',
            number_of_game: 0,
        },
    ],
    all: [
        {
            name: 'Techplay',
            key: 'techplay',
            number_of_game: 0,
        },
        {
            name: 'RedTiger',
            key: 'redtiger',
            number_of_game: 19,
        },
    ],
}

export const useSportsStore = defineStore('sportsStore', () => {
    const fetcher = useCustomFetch()

    // o-sport: v1/athena/sportUrl
    // s-sport: v1/tp/ssportUrl
    // k-sport: v1/tp/ksportUrl
    // t-sport: v1/tp/tsportUrl
    const sportUrl = ref('')

    const getSportUrl = async (sportApi) => {
        try {
            const { data } = await fetcher.get(sportApi)
            // if (data.value?.status === STATUS_OK) {
            //     sportUrl.value = data.value?.data?.url
            // }
            return { data: data.value }
        } catch (error) {
            console.log('sportsStore', error)
        }
    }

    const restSportUrl = () => {
        sportUrl.value = ''
    }

    const sportItems = ref([
        // BTI
        {
            id: 'bti',
            order: 3,
            key: 'bti',
            title: 'bti',
            name: 'v2-bti',
            api_url: '/tp/ssportUrl?loginPath=ssports?login=true',
            page_url: '/btisports',
            url: '/btisports',
            logo: '/assets/img/v2/sports/sportbook/bti-icon.png',
            image: '/assets/img/sports/sportbook/bti-card.png',
            imageMobile: '/assets/img/v2/sports/sportbook/bti-thumb-mb.png',
            imageDesktop: '/assets/img/v2/sports/sportbook/bti-thumb-pc.png',
            imageLable: '/assets/img/sports/sportbook/sport.png',
            require_auth: true,
            isRequireLogin: true,
        },
        // SABA
        {
            id: 'saba',
            order: 2,
            key: 'saba',
            title: 'saba',
            name: 'v2-saba',
            api_url: '/athena/sportUrl',
            page_url: '/saba-sports',
            url: '/saba-sports',
            logo: '/assets/img/v2/sports/sportbook/saba-icon.png',
            image: '/assets/img/sports/sportbook/saba-card.png',
            imageMobile: '/assets/img/v2/sports/sportbook/saba-thumb-mb.png',
            imageDesktop: '/assets/img/v2/sports/sportbook/saba-thumb-pc.png',
            imageLable: '/assets/img/sports/sportbook/sport.png',
            require_auth: false,
            isRequireLogin: false,
        },
        // K-SPORT
        {
            id: 'ksport',
            order: 1,
            title: 'k-sports',
            key: 'ksports',
            name: 'v2-ksport',
            api_url: '/tp/ksportUrl',
            page_url: '/ksports',
            url: '/ksports',
            logo: '/assets/img/v2/sports/sportbook/k-sports-icon.png',
            image: '/assets/img/sports/sportbook/ksport-card.png',
            imageMobile:
                '/assets/img/v2/sports/sportbook/k-sports-thumb-mb.png',
            imageDesktop:
                '/assets/img/v2/sports/sportbook/k-sports-thumb-pc.png',
            imageLable: '/assets/img/sports/sportbook/sport.png',
            require_auth: false,
            isRequireLogin: false,
        },
        // IM-SPORT
        {
            id: 'imsports',
            order: 4,
            title: 'im - sports',
            key: 'imsports',
            name: 'v2-imsports',
            api_url: '/gameUrl?p=im&gId=sport',
            page_url: '/im-sports',
            url: '/im-sports',
            logo: '/assets/img/v2/sports/sportbook/im-sports-icon.png',
            image: '/assets/img/sports/sportbook/ksport-card.png',
            imageMobile:
                '/assets/img/v2/sports/sportbook/im-sports-thumb-mb.png',
            imageDesktop:
                '/assets/img/v2/sports/sportbook/im-sports-thumb-pc.png',
            imageLable: '/assets/img/sports/sportbook/sport.png',
            require_auth: true,
            isRequireLogin: true,
        },
    ])
    const sportVirtualItems = ref([
        // SABA VIRTUAL
        {
            id: 'saba',
            order: 3,
            key: 'saba',
            name: 'v2-virtual-saba',
            title: 'saba',
            api_url: '/athena/virtualSportUrl?loginPath=saba-sports?login=true',
            page_url: '/virtual-saba-sports',
            url: '/virtual-saba-sports',
            logo: '/assets/img/v2/sports/virtualsport/saba-icon.png',
            image: '/assets/img/sports/virtualsport/saba-card.png',
            imageMobile: '/assets/img/v2/sports/virtualsport/saba-thumb-mb.png',
            imageDesktop: '/assets/img/v2/sports/virtualsport/saba-thumb-pc.png',
            imageLable: '/assets/img/sports/virtualsport/virtualsports.png',
            require_auth: false,
            isRequireLogin: false,
        },
        // IN PLAY VIRTUAL
        {
            id: 'implay',
            order: 2,
            key: 'implay',
            name: 'v2-virtual-implay',
            title: 'im - play',
            api_url: '/gameUrl?p=im&gId=virtualsport',
            page_url: '/in-play',
            url: '/in-play',
            logo: '/assets/img/v2/sports/virtualsport/im-play-icon.png',
            image: '/assets/img/sports/virtualsport/inplay-card.png',
            imageMobile:
                '/assets/img/v2/sports/virtualsport/im-play-thumb-mb.png',
            imageDesktop:
                '/assets/img/v2/sports/virtualsport/im-play-thumb-pc.png',
            imageLable: '/assets/img/sports/virtualsport/virtualsports.png',
            require_auth: false,
            isRequireLogin: false,
        },
        // KSPORT VIRTUAL
        {
            id: 'ksport',
            order: 1,
            key: 'ksports',
            name: 'v2-virtual-ksport',
            title: 'k-sports',
            api_url: '/tp/ksportUrl?isvirtual=true',
            page_url: '/virtual-ksports',
            url: '/virtual-ksports',
            logo: '/assets/img/v2/sports/virtualsport/k-sports-icon.png',
            image: '/assets/img/sports/virtualsport/ksport-card.png',
            imageMobile:
                '/assets/img/v2/sports/virtualsport/k-sports-thumb-mb.png',
            imageDesktop:
                '/assets/img/v2/sports/virtualsport/k-sports-thumb-pc.png',
            imageLable: '/assets/img/sports/virtualsport/virtualsports.png',
            require_auth: false,
            isRequireLogin: false,
        },
        // PPSPORTS
        {
            id: 'ppsports',
            order: 4,
            key: 'ppsports',
            name: 'v2-virtual-ppsports',
            title: 'pp-sports',
            api_url: 'gameUrl?partnerProvider=betradar&partnerGameId=vfb',
            page_url: '/virtual-pp-sports',
            url: '/virtual-pp-sports',
            logo: '/assets/img/v2/sports/virtualsport/pp-sports-icon.png',
            image: '/assets/img/sports/virtualsport/betradar-card.png',
            imageMobile:
                '/assets/img/v2/sports/virtualsport/pp-sports-thumb-mb.png',
            imageDesktop:
                '/assets/img/v2/sports/virtualsport/pp-sports-thumb-pc.png',
            imageLable: '/assets/img/sports/virtualsport/virtualsports.png',
            require_auth: false,
            isRequireLogin: false,
        },
    ])

    return {
        sportUrl,
        getSportUrl,
        restSportUrl,
        sportItems,
        sportVirtualItems,
    }
})
